export const ICON_BUTTON_CONTROL_ACTIONS = {
  DUPLICATE: 'duplicate',
  DELETE: 'delete',
  LOCK: 'lock',
  SAVE: 'save',
  CLEAR_SELECTION: 'clear-selection',
} as const;

export type IconButtonAction = (typeof ICON_BUTTON_CONTROL_ACTIONS)[keyof typeof ICON_BUTTON_CONTROL_ACTIONS];

export const enum SaveButtonState {
  IDLE = 'idle',
  SAVING = 'saving',
  SAVED = 'saved',
}

/** Icon CSS classes that flip at runtime for the lock toggle and save-state transitions. */
export const ICON_BUTTON_RUNTIME_ICONS = {
  LOCK: 'icon-lock',
  UNLOCK: 'icon-unlock',
  SAVING: 'icon-loader gear-clockwise-animation -selected',
  SAVED: 'icon-bookmark-filled',
} as const;

export const ICON_BUTTON_RUNTIME_LABEL_KEYS = {
  LOCK: 'pmwjs_lock',
  UNLOCK: 'pmwjs_unlock',
  SAVING: 'pmwjs_saving',
  SAVED: 'pmwjs_saved',
} as const;

export interface IconButtonControlDescriptor {
  action: IconButtonAction;
  labelKey: string;
  iconClass: string;
}

export interface ComputeIconClassParams {
  descriptor: IconButtonControlDescriptor;
  isLockButton: boolean;
  isDraggable: boolean;
  isSaveButton: boolean;
  saveState: SaveButtonState;
}

export interface ComputeLabelKeyParams {
  descriptor: IconButtonControlDescriptor;
  isLockButton: boolean;
  isDraggable: boolean;
}

/** Shared render-state + click handler for one icon-button action, consumed by both the desktop control and the mobile strip item. */
export interface IconButtonActionState {
  iconClass: string;
  label: string;
  captionText: string;
  handleClick: () => void;
  isDeleteButton: boolean;
  isClearSelection: boolean;
  isSaveBusy: boolean;
}
